export default function Label({ title, children, cls }) {
  return (
    <>
      <div className="pr-h">{title}</div>
      <div className={cls}>{children}</div>
    </>
  );
}
